module.exports = __webpack_public_path__ + "static/media/cards.a91b16f6.png";